/** Consistent empty-state copy for blank beta workspaces. */
export const BETA_EMPTY_STATES = {
  sites: {
    title: "No job sites yet",
    description:
      "Create your first job site to start tracking labor, equipment, and payroll data.",
    actionLabel: "Create Site",
  },
  workers: {
    title: "No workers yet",
    description:
      "Add workers manually or import a CSV with employee IDs, trades, crews, and base rates.",
    actionLabel: "Add Workers",
    secondaryActionLabel: "Import CSV",
  },
  equipment: {
    title: "No equipment yet",
    description: "Add machines, vehicles, tools, or rentals used on site.",
    actionLabel: "Add Equipment",
  },
  payRules: {
    title: "No pay rules yet",
    description:
      "Create your first rule profile for overtime, weekends, holidays, and premiums.",
    actionLabel: "Create Pay Rule",
  },
  payPeriods: {
    title: "No pay period yet",
    description:
      "Start a pay period to collect daily field entries and prepare payroll.",
    actionLabel: "Start Pay Period",
  },
  fieldEntry: {
    title: "No field entries yet",
    description:
      "Once your workers and pay period are ready, submit your first field entry.",
    actionLabel: "Start Field Entry",
  },
} as const;
